import React from 'react';
import { useFormContext } from 'react-hook-form';
import { IconsTypesProps } from 'src/assets/icons/types';
import { CRANE_PUMP, PUMP_2 } from 'src/features/sites';

type Props = {
  subTypes: any;
  widgetIcon: React.FunctionComponent<IconsTypesProps>;
};

export const SelectedWidgetIcon = ({ subTypes, widgetIcon }: Props) => {
  const { watch } = useFormContext();
  const selectedWidgetSubType = watch('widgetSubType');
  const selectedTypeObject = subTypes?.find((item: any) => item.name === selectedWidgetSubType);

  const isPump2 = selectedTypeObject?.name === PUMP_2;
  const isCrane = selectedTypeObject?.name === CRANE_PUMP;
  const color = '#b3b3b3';

  let w = 70,
    h = 70;

  if (isCrane) {
    w = 50;
    h = 140;
  } else if (!isPump2) {
    w = 90;
    h = 90;
  }

  const IconComponent = selectedTypeObject?.icon || widgetIcon;

  return <IconComponent width={w} height={h} fill={color} />;
};
